import type { EntityPreviewEntityType } from "@/components/chat/embeds/types";

/** Entity kinds the agent can navigate to (list highlight or detail). */
export type AgentEntityKind = EntityPreviewEntityType;

export type AgentNavMode = "list_highlight" | "detail" | "app" | "artifact";

export type AgentNavIntent =
  | { mode: "list_highlight"; entityKind: AgentEntityKind; id: string }
  | { mode: "detail"; entityKind: AgentEntityKind; id: string; label?: string }
  | { mode: "app"; appId: string; params?: Record<string, string> }
  | { mode: "artifact"; artifactId: string; title?: string };

export type AgentListHighlightConfig = {
  focusKey: (id: string) => string;
  windowParams: (id: string) => Record<string, string>;
  routePath: string;
  routeQuery: (id: string) => Record<string, string>;
  stripDetailParamKeys: readonly string[];
};

export type AgentDetailConfig = {
  windowParamKey: string;
  routePath: (id: string) => string;
  windowTitle?: (label: string) => string;
  extraWindowParams?: Record<string, string>;
  /** When set, detail opens this app instead of the list app's appId. */
  detailAppId?: string;
};

export type AgentEntityDescriptor = {
  kind: AgentEntityKind;
  appId: string;
  /** OS window title for list-highlight navigation. */
  listWindowTitle: string;
  listHighlight?: AgentListHighlightConfig;
  detail?: AgentDetailConfig;
};

export type AgentOpenWindowTarget = {
  appId: string;
  title: string;
  params: Record<string, string>;
};

export type AgentNavigateHref = {
  path: string;
  search: string;
};

export type AgentNavResolved =
  | { kind: "window"; target: AgentOpenWindowTarget }
  | { kind: "href"; target: AgentNavigateHref };

export const LIST_FOCUS_DETAIL_PARAM_KEYS = [
  "caseId",
  "case_id",
  "meetingId",
  "meeting_id",
  "missionId",
  "mission_id",
  "taskId",
  "task_id",
  "task",
] as const;
